import InquiryDetails from "legacy/inquiries/InquiryDetails"
import PropTypes from "prop-types"
import React from "react"

class EmbeddedInquiryShow extends React.Component {
  renderInquiryDetailControls() {
    return (
      <div className="inquiry-controls flex flex-wrap items-baseline justify-between gap-4 pb-4">
        <div className="flex whitespace-nowrap text-base font-bold">
          <a href={this.props.marina.destinationPath}>
            {this.props.marina.name}
          </a>
        </div>
        <div className="flex">
          <a
            className="btn btn-secondary w-full"
            href={this.props.inquiry.viewPath}
            target="_blank"
            rel="noreferrer"
          >
            View in Dockwa
          </a>
        </div>
      </div>
    )
  }

  renderInquiryDetailSection() {
    return (
      <div className="inquiry-details mb-4 border-t pt-4">
        <div className="flex flex-wrap sm:justify-between">
          <div className="w-full border-0 pb-4 sm:mb-4 sm:border-b">
            {`You have successfully submitted an inquiry to ${this.props.marina.name}! Marinas typically respond within 7 days`}
          </div>
          <InquiryDetails inquiry={this.props.inquiry} embed={true} />
        </div>
        <div className="my-4 border-t py-4 text-center">
          <div className="font-bold">Request</div>
          <div className="mt-4">{this.props.inquiry.request}</div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.renderInquiryDetailControls()}
        {this.renderInquiryDetailSection()}
      </div>
    )
  }
}

EmbeddedInquiryShow.propTypes = {
  marina: PropTypes.shape({
    name: PropTypes.string.isRequired,
    destinationPath: PropTypes.string,
  }).isRequired,
  inquiry: PropTypes.shape({
    viewPath: PropTypes.string,
    request: PropTypes.string,
  }).isRequired,
}

export default EmbeddedInquiryShow
